import React, { Component } from 'react';
import {Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap';

export class MessagePanel extends Component {

  render() {
    return (
      <div className="ibox float-e-margins">
          <div className="ibox-title">
              <h5>Messages</h5>

          </div>
          <div className="ibox-content ibox-heading">
              <h3><i className="fa fa-envelope-o"></i> New messages</h3>
              <small><i className="fa fa-tim"></i> You have 22 new messages and 16 waiting in draft folder.</small>
          </div>
          <div className="ibox-content">
              <div className="feed-activity-list">

                  <div className="feed-element">
                      <div>
                          <small className="pull-right text-navy">1m ago</small>
                          <strong>System Message</strong>
                          <div>Driver Jose Gutierrez is 45 minutes ahead of schedule. Dropoff location notified and will try and unload early.</div>
                      </div>
                  </div>

                  <div className="feed-element">
                      <div>
                          <small className="pull-right">2m ago</small>
                          <strong>Email: john.schwarz@insuranceco.com </strong>
                          <div>Subject: I uploaded New Certificates of Insurance for Driver Margaret Johnson to NXXT</div>

                      </div>
                  </div>

                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div>Received updated Certificates of Insurance for Driver Margaret Johnson</div>
                      </div>
                  </div>

                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div>Due to traffic delay Driver John Braxton is within 95% of maximum allowable Driving Time for this period.</div>
                      </div>
                  </div>


                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>Email: jshane@dmxproducts.com</strong>
                          <div>Subject: Need to increase the insurance coverage on tomorrow’s load.</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div>Load #36798, Apax Corp Completed, BOL and POD in System, Payment $784.34 by ACH Confirmed Tomorrow</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div>Load # 36793 value over insured limit. Contact Shipper DMX Products and increase coverage by $47,560.</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>Chat with Joel at DMX Products</strong>
                          <div>Hi Hillary, got a notification we need to update Insurance coverage. Will there be an additional charge?</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div>Severe Weather Alert: Blizzards in Detroit, MI area may impact Driver John Braxton Pickup # 36789</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div> Load #36794 Delivery Completed, BOL & POD Uploaded. Payment received CargoCoins 229.4</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div> Maintenance Alert: Driver Jose Gutierrez, Volvo D13 needs scheduled brake maintenance. RFQ Issued</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div> Maintenance Quote: Driver Jose Gutierrez, Volvo D13 quote received for maintenance $389.99</div>
                      </div>
                  </div>
                  <div className="feed-element">
                      <div>
                          <small className="pull-right">5m ago</small>
                          <strong>System Message</strong>
                          <div> Maintenance Quote: Driver Jose Gutierrez, Volvo D13 quote received for maintenance $410.00</div>
                      </div>
                  </div>

              </div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MessagePanel.js